
import card from './components/card.vue'
import valueimg from '@/assets/lalisai/value.png'
import html2canvas from 'html2canvas'
import config from '@/config'
import { personBasic, endPanduan, inviteTimes } from '@/api/lalisai'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Qrcode from 'vux/src/components/qrcode/index.vue'
import ConfigPlugin from 'vux/src/plugins/config/index.js'





export default {
directives: {
TransferDom
},
components: { card, XDialog, Qrcode },
name: 'invite',
props: {},
data () {
return {
title: '邀请好友',
active: 0,
valueimg: valueimg,
num: 0,
showcard: false,
qrcodeUrl: '',
downImgUrl: '',
partyId: '1'
}
},
created () {
endPanduan({
partyId: this.partyId
}).then(res => {
if (!res.obj) {
this.$router.push({ name: 'lalisaiIndex' })
}
})
},
mounted () {
this.getnum()

},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
methods: {
invite () {
this.showcard = true
this.share()
},








getnum () {
inviteTimes({
inviter: this.accountid,
partyId: this.partyId
}).then(data => {
this.num = data.obj
})
},
share () {
this.qrcodeUrl =
'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
config.appid +
'&redirect_uri=' +
window.location.origin + '/youzheng/wechat/youzheng/lalisai/index' +
'?obj=' + this.accountid +
'/&response_type=code&scope=snsapi_base&state=200&connect_redirect=1#wechat_redirect'
console.log('qr', this.qrcodeUrl)
console.log(window.location)
setTimeout(() => {
this.shareImg()
}, 500)
},

shareImg () {

html2canvas(this.$refs.imageWrapper, {
width: this.$refs.imageWrapper.clientWidth, // dom 原始宽度
height: this.$refs.imageWrapper.clientHeight,
scrollY: 0,
scrollX: 0,
useCORS: true
}).then(canvas => {
let dataURL = canvas.toDataURL('image/jpg')
this.downImgUrl = dataURL
})
},
returnback () {
this.$router.push({ name: 'lalisaiIndex' })
}
}
}
